import {gql} from '@apollo/client';

export const BATCH_UPDATE_PICKUP_TASK_STATUS = gql`
  mutation BatchUpdatePickupTaskStatus($taskIds: [String!]!, $status: PickupTaskStatus!, $warehouseId: Long!) {
    batchUpdateTaskStatus(taskIds: $taskIds, status: $status, warehouseId: $warehouseId) {
      successIds
      failedIds
      successCount
      failedCount
      failures {
        taskId
        taskNumber
        reasons
      }
    }
  }
`; 